import isPositiveInteger from "./isPositiveInteger";
import isInValueRange from "./isValueInRange";

const handleVariableAmountChange =
  (
    minValue: number,
    maxValue: number,
    setValue: (value: string) => void,
    setWarning: (value: string) => void,
  ) =>
  (e: any) => {
    const { value } = e.target;
    const number = Number(value);

    if (isPositiveInteger(value) || value === "" || number === 0) {
      const papMinValue = Math.max(minValue, 1);

      if (isInValueRange(number, papMinValue, maxValue) || value === "") {
        setWarning("");
      } else {
        setWarning(`Amount must be between $${papMinValue} and $${maxValue}`);
      }

      if (value === "") {
        setValue("");
      } else if (number === 0) {
        setValue("0");
      } else if (number < 999999) {
        setValue(String(number));
      }
    }
  };

export default handleVariableAmountChange;
